import React from "react";
import { Crown, Gavel, LogOut, Repeat, Music4 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AppHeader() {
  const { user, mode, switchMode, logout } = useAuth();
  const dual = user?.is_superadmin && user?.is_judge;
  const isAdmin = mode === "superadmin" && user?.is_superadmin;

  return (
    <header className="sticky top-0 z-50 bg-[#070B14]/90 backdrop-blur-xl border-b border-amber-500/20 px-4 py-3 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-amber-400 to-yellow-700 flex items-center justify-center shrink-0">
          <Music4 className="w-5 h-5 text-slate-950" />
        </div>
        <div className="min-w-0">
          <div className="font-display font-black text-sm sm:text-base uppercase tracking-tight text-amber-100 leading-none truncate">
            KWC Luzon 2026
          </div>
          <div className="flex items-center gap-1.5 mt-0.5">
            {isAdmin ? <Crown className="w-3 h-3 text-amber-400" /> : <Gavel className="w-3 h-3 text-slate-400" />}
            <span className="text-[11px] text-slate-400 truncate" data-testid="role-indicator">
              {isAdmin ? "SuperAdmin" : "Judge"} · {user?.name}
            </span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30">
          <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
          <span className="text-[10px] text-emerald-300 hidden sm:inline">Live</span>
        </div>
        {dual && (
          <button
            data-testid="role-switcher-toggle"
            onClick={switchMode}
            className="flex items-center gap-1.5 px-3 h-9 rounded-lg bg-slate-800 border border-amber-500/30 text-amber-200 text-xs font-semibold hover:bg-slate-700 transition-colors"
          >
            <Repeat className="w-4 h-4" />
            <span className="hidden sm:inline">{isAdmin ? "Judge Mode" : "Admin Mode"}</span>
          </button>
        )}
        <button
          data-testid="logout-button"
          onClick={logout}
          className="flex items-center justify-center w-9 h-9 rounded-lg bg-slate-800 border border-slate-700 text-slate-300 hover:text-red-400 hover:border-red-500/40 transition-colors"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}
